import { createSelector } from '@reduxjs/toolkit'
import { StoreState } from '../index'

const approvalFlowSelector = (state: StoreState) => state.approvalFlow
export const ApprovalFlowSelectors = {
  flows: createSelector([approvalFlowSelector], (state) => state.flows),
}
